"use client";

import * as React from "react";
import { cn } from "@/lib/utils";

export const classNameStyles = {
  default: "",
  admin: "w-full p-3 border border-gray-3 rounded-md bg-white text-black placeholder-gray-4 focus:border-primary-main focus:ring-2 focus:ring-primary-main/20 transition-colors resize-vertical",
} as const;

type StyleKey = keyof typeof classNameStyles;

export interface TextAreaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  classType?: StyleKey;
}

export const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ className, classType = "default", ...props }, ref) => {
    const classes = cn(
      // baseline styles
      "",
      // variant styles
      classType ? classNameStyles[classType] : undefined,
      // allow overrides
      className
    );

    return <textarea ref={ref} className={classes} {...props} />;
  }
);

TextArea.displayName = "TextArea";
